import React, { useState, useContext, useEffect } from 'react';
import { StateContext } from 'context';
import { Themes } from 'styles';
import './creditos-de-turismo.css';
import { CreditosDeTurismo1Img, CreditosDeTurismo2Img } from 'assets/img';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormularioPpCt } from 'app/formulario-pp-ct';
import { FormularioUnipersonalEmpresa } from 'app/formulario-unipersonal-empresa';
const CreditosDeTurismo = (props) => {
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [toggleAgencias, setToggleAgencias] = useState(false);
    const [verFormulario, setVerFormulario] = useState(false);
    const [verFormularioUnipersonal, setVerFormularioUnipersonal] = useState(false);
    useEffect(() => {
    }, []);
  
    return (
        <>
            <div id="creditos-de-turismo" className="w3-block">
                {/* <div className="w3-content w3-center w3-padding-large">

                </div> */}
                <div className="w3-content">
                    <div className="w3-row">
                        <div className="w3-col l4 m12 col-imagenes">
                            <div className="w3-row">
                                <div className="w3-col l12 m6 s6">
                                    <div className="w3-block w3-center w3-padding bs-bbox">
                                        <div className="img-container background-cover w3-card"
                                            style={{ backgroundImage: `url(${CreditosDeTurismo1Img})` }}>
                                        </div>
                                    </div>
                                </div>
                                <div className="w3-col l12 m6 s6">
                                    <div className="w3-block w3-center w3-padding bs-bbox">
                                        <div className="img-container background-cover w3-card"
                                            style={{ backgroundImage: `url(${CreditosDeTurismo2Img})` }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w3-rest w3-padding">
                            <h1 style={{ color: Themes[indexTema].D1 }}>Créditos de turismo</h1>
                            {/* <a className="img-servitravel" target="_blank" href="https://www.servitravel.com.py"><img src={LogoServitravel} alt="servitravel"/></a> */}
                            <p>Con SERFIN podrás hacer ese viaje que tanto anhelas y las vacaciones que te mereces, Participar de congresos, eventos, el viaje de luna de miel que siempre soñaste, accedé a servicios de paquetes aéreos y terrestres, regálale el viaje soñado de 15 años a tus hijos…y pagar en el plazo que vos desees con la cuota mas conveniente que solo SERFIN te puede ofrecer.</p>
                            <p>También puedes elegir el destino con <a id="link-servitravel" href="https://www.servitravel.com.py" target="_blank"><span className="w3-text-red">www.servitravel.com.py</span></a> y finánciarlo a través de SERFIN…</p>
                            {/* <p>También puedes elegir el destino con <span className="w3-text-red cursor-pointer" onClick={() => setToggleAgencias(!toggleAgencias)}>www.servitravel.com.py</span> y finánciarlo a través de SERFIN…</p> */}
                            {toggleAgencias ? <div className="w3-card w3-animate-zoom">
                                <div className="w3-block agencias-container">
                                    <div className="close-container">
                                        <button className="close-btn w3-btn w3-light-gray" onClick={() => setToggleAgencias(!toggleAgencias)}>
                                            <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                    </div>
                                </div>
                            </div> : null}
                            {/* {!verFormulario ? <button className="boton-formulario-online w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormulario(true)}>Solicitar</button> : null}                           */}
                            {(!verFormulario && !verFormularioUnipersonal) ? <button className="boton-formulario-online w3-margin-right w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormulario(true)}>Solicitar (Asalariado)</button> : null}
                            {(!verFormulario && !verFormularioUnipersonal) ? <button className="boton-formulario-online w3-margin-right w3-btn w3-xlarge w3-round-xxlarge w3-theme" onClick={() => setVerFormularioUnipersonal(true)}>Solicitar (Unipersonal)</button> : null}
                        </div>
                    </div>
                    {verFormulario ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormulario(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud (Asalariado)</h1>
                            </div>
                            
                            <FormularioPpCt tipoSolicitud={1} />
                        </div>
                    </div> : null}
                    {verFormularioUnipersonal ? <div>
                        <div className="w3-block w3-card w3-padding bs-bbox w3-animate-bottom">
                            <div className="w3-block" style={{ height: 50 }}>
                                <button className="close-btn w3-btn w3-light-gray" onClick={() => setVerFormularioUnipersonal(false)}>
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                                <h1 style={{ color: Themes[indexTema].D1 }}>Solicitud Préstamo (Unipersonal)</h1>
                            </div>
                            <FormularioUnipersonalEmpresa tipoSolicitud={2}/>
                        </div>
                    </div> : null}
                </div>
            </div>
        </>
    );
}
export default CreditosDeTurismo;